/* KIRUTO · animaciones e interacciones (sin librerías) */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && root.dataset.kAnim !== 'off') root.classList.add('k-anim');

  /* ---------- Entradas al hacer scroll ---------- */
  let io;
  const observe = (scope = document) => {
    if (!('IntersectionObserver' in window)) {
      scope.querySelectorAll('[data-reveal],.k-split,.k-tile,[data-count],.k-cta__card').forEach(el => el.classList.add('is-in'));
      return;
    }
    io = io || new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    scope.querySelectorAll('[data-reveal],.k-split,.k-tile,[data-count],.k-cta__card').forEach(el => io.observe(el));
  };

  /* ---------- Titulares palabra a palabra ---------- */
  const split = (scope = document) => {
    scope.querySelectorAll('[data-split]:not(.k-split)').forEach(el => {
      const d = el.style.getPropertyValue('--d');
      let i = 0;
      const walk = node => {
        [...node.childNodes].forEach(n => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(part => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              const w = document.createElement('span'); w.className = 'k-split-word';
              const s = document.createElement('span'); s.textContent = part; s.style.setProperty('--w', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
        });
      };
      walk(el);
      el.classList.add('k-split');
      if (d) el.style.setProperty('--d', d);
    });
  };

  /* ---------- Contadores ---------- */
  const fmt = (n, dec) => n.toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  function countUp(el) {
    const to = parseFloat(el.dataset.count); if (isNaN(to)) return;
    const dec = (el.dataset.count.split('.')[1] || '').length;
    if (reduce) { el.textContent = fmt(to, dec); return; }
    const dur = 1800, t0 = performance.now();
    const tick = t => { const p = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - p, 4); el.textContent = fmt(to * e, dec); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }

  /* ---------- Efectos ligados al scroll (parallax, texto que se ilumina, línea de pasos) ---------- */
  const scrollFx = () => {
    const vh = window.innerHeight;
    document.querySelectorAll('.k-hero[data-parallax] .k-hero__bg img').forEach(img => {
      const r = img.closest('.k-hero').getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      img.style.setProperty('--k-par', `${Math.round(-r.top * 0.18)}px`);
    });
    document.querySelectorAll('.k-statement__text').forEach(el => {
      const words = el.querySelectorAll('.k-w'); if (!words.length) return;
      const r = el.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      const lit = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', i < lit));
    });
    document.querySelectorAll('.k-steps').forEach(sec => {
      const grid = sec.querySelector('.k-steps__grid'); if (!grid) return;
      const r = grid.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (vh * 0.7 - r.top) / (r.height * 0.8)));
      const line = sec.querySelector('.k-steps__line i'); if (line) line.style.setProperty('--p', p.toFixed(3));
      const steps = sec.querySelectorAll('.k-step');
      steps.forEach((s, i) => s.classList.toggle('is-lit', p >= i / Math.max(1, steps.length - 1) - 0.02 || window.innerWidth < 990));
    });
  };
  let ticking = false;
  const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { scrollFx(); ticking = false; }); };

  const statementWords = (scope = document) => {
    scope.querySelectorAll('.k-statement__text:not([data-ready])').forEach(el => {
      el.dataset.ready = '1';
      const walk = node => [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(part));
            else { const s = document.createElement('span'); s.className = 'k-w'; s.textContent = part; frag.appendChild(s); }
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
      walk(el);
    });
  };

  /* ---------- Botones magnéticos ---------- */
  const magnetic = (scope = document) => {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    scope.querySelectorAll('.k-btn[data-magnetic]').forEach(b => {
      if (b.dataset.mg) return; b.dataset.mg = '1';
      b.addEventListener('mousemove', e => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.3}px)`; });
      b.addEventListener('mouseleave', () => { b.style.transform = ''; });
    });
  };

  /* ---------- Selector de cabezales ---------- */
  const heads = (scope = document) => {
    scope.querySelectorAll('.k-heads').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const items = [...sec.querySelectorAll('.k-heads__item')];
      const imgs = [...sec.querySelectorAll('.k-heads__img')];
      const badge = sec.querySelector('.k-heads__badge');
      const delay = parseFloat(sec.dataset.rotate || 0) * 1000;
      let cur = 0, timer;
      const go = i => {
        cur = (i + items.length) % items.length;
        items.forEach((it, j) => { it.classList.toggle('is-active', j === cur); it.querySelector('.k-heads__btn').setAttribute('aria-expanded', j === cur); });
        imgs.forEach((im, j) => im.classList.toggle('is-active', j === cur));
        if (badge) badge.textContent = items[cur].dataset.name || '';
        items[cur].querySelectorAll('.k-heads__progress').forEach(p => { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; });
        schedule();
      };
      const schedule = () => { clearTimeout(timer); if (delay && !sec.classList.contains('is-paused')) timer = setTimeout(() => go(cur + 1), delay); };
      items.forEach((it, i) => it.querySelector('.k-heads__btn').addEventListener('click', () => { sec.classList.add('is-paused'); clearTimeout(timer); go(i); }));
      go(0);
    });
  };

  /* ---------- Galería de producto ---------- */
  const gallery = (scope = document) => {
    scope.querySelectorAll('.k-pdp__gallery').forEach(g => {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      const track = g.querySelector('.k-pdp__slides'); if (!track) return;
      const slides = [...track.children];
      const thumbs = [...g.querySelectorAll('.k-pdp__thumb')];
      const dots = [...g.querySelectorAll('.k-pdp__dots i')];
      const set = i => { thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i)); dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
      const to = i => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); set(i); };
      g._to = to;
      thumbs.forEach((t, i) => t.addEventListener('click', () => to(i)));
      g.querySelector('[data-prev]')?.addEventListener('click', () => to(Math.round(track.scrollLeft / track.clientWidth) - 1));
      g.querySelector('[data-next]')?.addEventListener('click', () => to(Math.round(track.scrollLeft / track.clientWidth) + 1));
      track.addEventListener('scroll', () => set(Math.round(track.scrollLeft / track.clientWidth)), { passive: true });
    });
  };

  /* ---------- Formulario de producto (variantes, cantidad, añadir al carrito) ---------- */
  const money = (cents, sec) => {
    const f = sec.dataset.moneyFormat || '${{amount}}';
    const v = (cents / 100);
    const n = f.includes('amount_no_decimals') ? Math.round(v).toLocaleString('es-CO') : v.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n.replace(/,00$/, ''));
  };
  const pdp = (scope = document) => {
    scope.querySelectorAll('.k-pdp').forEach(sec => {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      const form = sec.querySelector('form.k-pdp__form'); if (!form) return;
      const dataEl = sec.querySelector('script[data-variants]');
      const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      const idInput = form.querySelector('input[name="id"]');
      const add = form.querySelector('.k-pdp__add');
      const addLabel = add?.querySelector('[data-label]');
      const priceEl = sec.querySelector('[data-price]'), compareEl = sec.querySelector('[data-compare]'), saveEl = sec.querySelector('[data-save]');
      const stickyPrice = document.querySelector(`#k-sticky-${sec.dataset.section} [data-price]`);
      const msg = form.querySelector('.k-pdp__msg');

      const update = () => {
        const chosen = [...sec.querySelectorAll('.k-pdp__variants')].map(fs => fs.querySelector('input:checked')?.value);
        const v = variants.find(x => x.options.every((o, i) => o === chosen[i])); if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, sec);
        if (stickyPrice) stickyPrice.textContent = money(v.price, sec);
        const on = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.hidden = !on; if (on) compareEl.textContent = money(v.compare_at_price, sec); }
        if (saveEl) { saveEl.hidden = !on; if (on) saveEl.textContent = saveEl.dataset.tpl.replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100)); }
        if (add) { add.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? addLabel.dataset.available : addLabel.dataset.soldout; }
        if (v.featured_media && sec.querySelector('.k-pdp__gallery')?._to) {
          const idx = [...sec.querySelectorAll('.k-pdp__slide')].findIndex(s => s.dataset.media == String(v.featured_media)); if (idx > -1) sec.querySelector('.k-pdp__gallery')._to(idx);
        }
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      };
      sec.querySelectorAll('.k-pdp__variants input').forEach(i => i.addEventListener('change', update));

      const qty = form.querySelector('.k-qty input');
      form.querySelectorAll('.k-qty button').forEach(b => b.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value) || 1) + (b.dataset.step === '+' ? 1 : -1)); }));

      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (!add || add.disabled) return;
        add.classList.add('is-loading'); if (msg) msg.textContent = '';
        try {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData(form);
          if (cart && cart.getSectionsToRender) { body.append('sections', cart.getSectionsToRender().map(s => s.id)); body.append('sections_url', location.pathname); }
          const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
          const res = await r.json();
          if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
          if (cart && cart.renderContents) { cart.classList.remove('is-empty'); cart.renderContents(res); }
          else window.location = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (err) { form.submit(); }
        finally { add.classList.remove('is-loading'); }
      });

      /* Barra fija de compra */
      const sticky = document.getElementById(`k-sticky-${sec.dataset.section}`);
      if (sticky && 'IntersectionObserver' in window) {
        const foot = document.querySelector('.k-footer, .footer');
        let pastBuy = false, atFoot = false;
        const sync = () => sticky.classList.toggle('is-visible', pastBuy && !atFoot);
        new IntersectionObserver(([en]) => { pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0; sync(); }).observe(form);
        if (foot) new IntersectionObserver(([en]) => { atFoot = en.isIntersecting; sync(); }).observe(foot);
        sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
      }
    });
  };

  /* ---------- Antes / después ---------- */
  const beforeAfter = (scope = document) => {
    scope.querySelectorAll('[data-ba]').forEach(f => {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      const sec = f.closest('.k-ba'); const range = f.querySelector('.k-ba__range');
      const set = v => sec.style.setProperty('--k-ba-pos', `${v}%`);
      let touched = false;
      range.addEventListener('input', () => { touched = true; set(range.value); });
      range.addEventListener('pointerdown', () => f.classList.add('is-dragging'));
      window.addEventListener('pointerup', () => f.classList.remove('is-dragging'));
      /* Pequeña demostración al aparecer, para que se entienda que se puede deslizar */
      if (reduce || !('IntersectionObserver' in window)) return;
      const start = parseFloat(range.value);
      new IntersectionObserver(([e], o) => {
        if (!e.isIntersecting) return; o.disconnect();
        const keys = [start, start - 22, start + 18, start]; const dur = 2600, t0 = performance.now();
        const tick = t => {
          if (touched) return;
          const p = Math.min(1, (t - t0) / dur), seg = p * (keys.length - 1), i = Math.min(keys.length - 2, Math.floor(seg)), k = seg - i;
          const ease = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
          const v = keys[i] + (keys[i + 1] - keys[i]) * ease; set(v); range.value = v;
          if (p < 1) requestAnimationFrame(tick);
        };
        setTimeout(() => requestAnimationFrame(tick), 600);
      }, { threshold: 0.5 }).observe(f);
    });
  };

  const init = scope => { split(scope); statementWords(scope); observe(scope); magnetic(scope); heads(scope); gallery(scope); pdp(scope); beforeAfter(scope); scrollFx(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Editor de Shopify: reiniciar al editar una sección */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const it = e.target.closest('.k-heads__item'); if (it) it.querySelector('.k-heads__btn')?.click();
    e.target.querySelectorAll?.('[data-reveal]').forEach(el => el.classList.add('is-in'));
    e.target.classList?.add('is-in');
  });
})();
